import React from 'react';
import { Icon, IconName } from '@usealloy/component-library';

export function getTagNodeIcon(args: {
  hasOutcomes: boolean;
  isCaseGenerating: boolean;
  iconColor: string;
}) {
  const { hasOutcomes, isCaseGenerating, iconColor } = args;
  if (hasOutcomes) return <Icon color={iconColor} icon={IconName.Stamp} size="small" />;
  if (isCaseGenerating) return <Icon color={iconColor} icon={IconName.Opened} size="large" />;
  return null;
}
